/**
 *
 * Block
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import Formatted from "basicComponents/FormattedDate/Formatted";
import { getColor } from "utils/timeGap";
import messages from "./messages";
import { DATE_FORMATS } from "../../utils/Date";
import moment from "moment";

export const WIDTH = 5;
export const MARGIN = 1;
// It's a square
// noinspection JSSuspiciousNameCombination
export const HEIGHT = WIDTH;

export default class Block extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    data: PropTypes.shape({
      planned_date_time_from: PropTypes.string.isRequired,
      planned_date_time_to: PropTypes.string.isRequired,
    }).isRequired,
    offset: PropTypes.number,
    hideTime: PropTypes.bool,
    noMargin: PropTypes.bool,
    duration: PropTypes.number,
    gray: PropTypes.bool,
    colorFunction: PropTypes.func,
    scale: PropTypes.number,
    color: PropTypes.string,
  };

  static defaultProps = {
    offset: 0,
    duration: 0,
    scale: 1,
    colorFunction: getColor,
  };

  handleClicked = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.data);
    }
  };

  render() {
    const { data, offset, duration, gray } = this.props;
    let color = this.props.color;
    if (!color) {
      color = getColor(
        duration,
        data.durationMin,
        data.occupiedMin,
        data.maxGapMin,
        gray,
      );
    }

    const id = data.planned_date_time_from;
    const cypressFormat = moment(id).format("DD-MM-YYYY");

    return (
      <ItemWrapper
        noMargin={this.props.noMargin}
        onClick={this.handleClicked}
        offset={offset}
        gray={gray}
        scale={this.props.scale}
      >
        <ItemContentWrapper
          color={color}
          gray={gray}
          id={id.replace(/\s/g, "-")}
          className="Block"
          data-cy={cypressFormat}
        >
          <ItemBoxHeader color={color}>
            <HeaderText>
              <Formatted date={data.planned_date_time_from} format="dddd" />
            </HeaderText>
          </ItemBoxHeader>
          <ItemBox noMargin={this.props.noMargin} color={color}>
            <ItemBoxContent>
              <Formatted date={data.planned_date_time_from} format="DD" />
            </ItemBoxContent>
            <ItemBoxFooter>
              <Formatted date={data.planned_date_time_from} format="MMMM" />
            </ItemBoxFooter>
          </ItemBox>
        </ItemContentWrapper>
        {!this.props.hideTime && (
          <>
            <BottomText>
              <FormattedMessage {...messages.from} />{" "}
              <Formatted
                date={data.planned_date_time_from}
                format={DATE_FORMATS.HUMAN_READABLE_TIME}
              />
            </BottomText>
            <BottomText>
              <FormattedMessage {...messages.to} />{" "}
              <Formatted
                date={data.planned_date_time_to}
                format={DATE_FORMATS.HUMAN_READABLE_TIME}
              />
            </BottomText>
          </>
        )}
      </ItemWrapper>
    );
  }
}

const ItemContentWrapper = styled.div`
  color: ${({ theme, gray }) => (gray ? theme.disabledColor : "black")};
  border: 2px solid ${({ color }) => color};
  border-radius: 15px;
  height: ${HEIGHT}rem;
  width: ${WIDTH}rem;
  &:hover {
    ${({ theme }) => theme.boxShadow};
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  cursor: pointer;
  transform: translate(${({ offset }) => offset}rem)
    scale(${({ scale }) => scale});
  margin-right: ${({ noMargin }) => (noMargin ? 0 : MARGIN)}rem;
  transition: transform 200ms ease-in-out;
`;

const ItemBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : "10px")};
  overflow: hidden;
  width: 100%;
`;

const ItemBoxHeader = styled.div`
  background-color: ${({ color }) => color};
  height: auto;
  width: calc(100% + 2px);
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-top: -1px;
  margin-left: -1px;
`;

const HeaderText = styled.div`
  height: 20px;
  color: white;
  margin-left: -1px;
  font-size: 12px;
  text-align: center;
`;

const BottomText = styled.div`
  display: inline-block;
  justify-content: center;
  text-align: center;
  margin-block-start: unset;
  margin-block-end: unset;
  font-size: 12px;
`;

const ItemBoxContent = styled.div`
  height: 100%;
  font-size: 30px;
  text-align: center;
  margin-bottom: -10px;
  font-weight: bold;
`;

const ItemBoxFooter = styled.div`
  height: 100%;
  font-size: 0.75rem;
  text-align: center;
  text-transform: uppercase;
`;
